export const APP_NAME = 'Mind Labs';

export const BASE_URL =
  process.env.BASE_URL || `https://${process.env.VERCEL_URL}`;

export const VERCEL_ENV = process.env.VERCEL_ENV;
export const WEBSITE_URL =
  process.env.NEXT_PUBLIC_BASE_URL || 'https://www.learnwithexplore.com';

export const NEXT_PUBLIC_BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL || `https://${process.env.VERCEL_URL}`;

export const WEBAPP_URL = WEBSITE_URL || 'http://localhost:3000';
export const IS_PRODUCTION =
  process.env.NEXT_PUBLIC_ENV_STATUS === 'production';

export const Routes = {
  SITE: {
    HOME: '/',
    DASHBOARD: '/dashboard',
    ADMIN_DASHBOARD: '/admin/dashboard',
    ADMIN_LIST_USERS: '/admin/users',
    ADMIN_PROFILE: '/profile/:adminId',
    TEACHER_PROFILE: '/profile/:teacherId',
    STUDENT_PROFILE: '/profile/:studentId',
    STUDENT_HOME: '/dashboard',
    // Legacy compatibility route retained for redirects.
    STUDENT_ASSIGNMENTS: '/assignments',
    STUDENT_ASSIGNMENT: '/assignment/:assignmentId',
    TEACHER_ROSTER: '/roster',
    TEACHER_CLASSROOMS: '/classrooms',
    TEACHER_CLASSROOM: '/classroom/:classroomId',
    TEACHER_CLASSROOM_ASSIGNMENT:
      '/classroom/:classroomId/assignment/:assignmentId',
    TEACHER_CLASSROOM_ASSIGNMENT_GROUPS:
      '/classroom/:classroomId/assignment/:assignmentId/groups',
    TEACHER_CLASSROOM_ASSIGNMENT_ANALYTICS:
      '/classroom/:classroomId/assignment/:assignmentId/analytics',
    TEACHER_CLASSROOM_ASSIGNMENT_LOGS:
      '/classroom/:classroomId/assignment/:assignmentId/logs',
    TEACHER_CLASSROOM_ASSIGNMENT_EDIT:
      '/classroom/:classroomId/assignment/:assignmentId/edit',
    TEACHER_CLASSROOM_ASSIGNMENT_ROOM_CODES:
      '/classroom/:classroomId/assignment/:assignmentId/groups/room-codes',
    TEACHER_CLASSROOM_GROUP: '/classroom/:classroomId/groups',
    TEACHER_CLASSROOM_ACTIVE: '/classroom/:classroomId/active',
    SETTINGS_MY_ACCOUNT_CLEVER: '/settings/my-account/clever',

    TEACHER_TASKS: '/notebooks',
    TEACHER_NOTEBOOKS: '/notebooks',
    TEACHER_FRAMEWORKS: '/frameworks',
    TEACHER_RESOURCES: '/resources',
    REGISTER: '/auth/signup',
    LOGIN: '/auth/signin',
    PROFILE: '/settings/my-account/profile',
    USERS: '/users',
    ORGANIZATIONS: '/organizations',
    PARTNER_ORGANIZATIONS: '/partner/organizations',
    _500: '/500',
    VERIFY_ACCOUNT: '/auth/verify-account',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    CHANGE_PASSWORD: '/auth/change-password',
    LOGOUT: '/auth/logout',
    NOT_FOUND: '/404',
    LAUNCH_GAME: '/game/p?token=:token',
  },
  API: {
    I18N: '/api/i18n',
    USERS: '/api/users',
    STUDENTS: '/api/students',
    PROFILE: '/api/users/:id',
    SESSION: '/api/auth/session',
    CLASSROOMS: '/api/classrooms',
    GROUPS: 'api/groups',
    CLASSROOM_ACCESS_CODE: '/api/classrooms/access-code',
    ASSIGNMENTS: '/api/assignments',
    ASSIGNMENT_SUPER_SET_DATA:
      '/api/assignments/reports/challenge-set/collection',
    ASSIGNMENT_NAME_CONFLICTS: '/api/assignments/name-conflicts',
    NOTEBOOKS: '/api/notebooks',
    RESOURCES: '/api/resources',
    // Compatibility alias during task->notebook transition.
    TASKS: '/api/tasks',
    DASHBOARD: '/api/dashboard',
    RESET_PASSWORD: '/api/auth/reset-password',
    FORGOT_PASSWORD: '/api/auth/forgot-password',
    VERIFY_ACCOUNT: '/api/auth/verify-account',
    RESEND_VERIFICATION: '/api/auth/resend-verification',
    GROUPSETS: '/api/classrooms/:classroomId/groupsets',
    GROUPSET: '/api/classrooms/:classroomId/groupsets/:groupsetId',
    CLASSROOM_GROUP: '/api/classrooms/:classroomId/groups/:groupId',
    CLASSROOM_MEMBERS: '/api/classrooms/:classroomId/members',
    ORGANIZATION_CLASSROOM_STUDENTS:
      '/api/organizations/:organizationId/classrooms/:classroomId/students',
    LIKES: '/api/likes',
    MESSAGES: '/api/assignments/:assignmentId/messages',
    TEXT_LABELS: '/api/text-labels',
    SUBSCRIPTIONS: '/api/subscriptions',
    ALL_PRODUCT_KEYS: '/api/subscriptions/all-product-keys',
    ANALYTICS: '/api/analytics/data',
    ANALYTICS_ASSIGNMENTS: '/api/analytics/assignments',
    ANALYTICS_CLASSROOMS: '/api/analytics/classrooms',
    ANALYTICS_STUDENTS: '/api/analytics/students',
    ANALYTICS_TEACHERS: '/api/analytics/teachers',
    ANALYTICS_GROUPS: '/api/analytics/groups',
    ANALYTICS_ORGANIZATIONS: '/api/analytics/organizations',
    ANALYTICS_ORGANIZATION_OVERVIEW: '/api/analytics/organization-overview',
    // Path segment is the canonical assignment set identifier.
    ASSIGNMENT_ANALYTICS: '/api/assignments/:assignmentSetId/analytics',
    ORGANIZATIONS: '/api/organizations',
    ORGANIZATION: '/api/organizations/:organizationId',
    ADMIN_JOBS_SCHEDULER_PREVIEW: '/api/admin/jobs/scheduler/preview',
    ADMIN_JOBS_SCHEDULER_APPLY: '/api/admin/jobs/scheduler/apply',
    ADMIN_DATABASE_HEALTH: '/api/admin/database-health',
    ADMIN_DATABASE_HEALTH_SNAPSHOT: '/api/admin/database-health/snapshot',
  },
} as const;

// ----------- redirects getServerSideProps

export const Redirects = {
  NOT_FOUND: {
    redirect: {
      destination: Routes.SITE.NOT_FOUND,
      permanent: false,
    },
  },
  _500: {
    redirect: {
      permanent: false,
      destination: Routes.SITE._500,
    },
  },
  LOGIN: {
    redirect: {
      permanent: false,
      destination: Routes.SITE.LOGIN,
    },
  },
  HOME: {
    redirect: {
      permanent: false,
      destination: Routes.SITE.HOME,
    },
  },
  DASHBOARD: {
    redirect: {
      permanent: false,
      destination: Routes.SITE.DASHBOARD,
    },
  },
  ASSIGNMENTS: {
    redirect: {
      permanent: false,
      destination: Routes.SITE.STUDENT_HOME,
    },
  },
  CLASSROOMS: {
    redirect: {
      permanent: false,
      destination: Routes.SITE.TEACHER_CLASSROOMS,
    },
  },
  ORGANIZATIONS: {
    redirect: {
      permanent: false,
      destination: Routes.SITE.ORGANIZATIONS,
    },
  },
  PARTNER_ORGANIZATIONS: {
    redirect: {
      permanent: false,
      destination: Routes.SITE.PARTNER_ORGANIZATIONS,
    },
  },
  TEACHER_CLASSROOM_ACTIVE_ASSIGNMENTS: {
    redirect: {
      permanent: false,
      destination: Routes.SITE.TEACHER_CLASSROOM_ACTIVE,
    },
  },
  PROFILE: {
    redirect: {
      permanent: false,
      destination: Routes.SITE.PROFILE,
    },
  },
} as const;

export const EDUCATOR_ASSIGNMENT_ROUTE_ROLES = [
  'TEACHER',
  'ADMIN',
  'EXPLORE_ADMIN',
] as const;

export const STUDENT_EXPERIENCE_ASSIGNMENT_ROUTE_ROLES = [
  'STUDENT',
  'COLLABORATOR',
] as const;

export const EDUCATOR_ASSIGNMENT_ROUTE_ROLE_SET = new Set<string>(
  EDUCATOR_ASSIGNMENT_ROUTE_ROLES
);

export const STUDENT_EXPERIENCE_ASSIGNMENT_ROUTE_ROLE_SET = new Set<string>(
  STUDENT_EXPERIENCE_ASSIGNMENT_ROUTE_ROLES
);

// grades for dropdown
export const GRADES = [
  { value: 'K', label: 'K' },
  { value: 'FIRST', label: '1st' },
  { value: 'SECOND', label: '2nd' },
  { value: 'THIRD', label: '3rd' },
  { value: 'FOURTH', label: '4th' },
  { value: 'FIFTH', label: '5th' },
  { value: 'SIXTH', label: '6th' },
  { value: 'SEVENTH', label: '7th' },
  { value: 'EIGHTH', label: '8th' },
  { value: 'MULTIPLE', label: 'Multiple' },
];

export const SELECTABLE_GRADES = GRADES.filter(
  (grade) => grade.value !== 'MULTIPLE'
);

// Units for dropdown
export const UNITS = [
  { value: 'ENERGY_AND_CIRCUITS', label: 'Energy and Circuits' },
  { value: 'COLABS_PLUS', label: 'Colabs Plus' },
  { value: 'FORCES_AND_MOTION', label: 'Forces and Motion' },
  { value: 'LIGHT_AND_SOUND', label: 'Light and Sound' },
  { value: 'HABITAT_AND_ADAPT', label: 'Habitat and Adapt' },
  { value: 'MANUFACTURE_AND_MATH', label: 'Manufacture and Math' },
];

export const CREATE_SPACE_UNIT_VALUES = [
  'ENERGY_AND_CIRCUITS',
  'FORCES_AND_MOTION',
  'COLABS_PLUS',
  'LIGHT_AND_SOUND',
  'HABITAT_AND_ADAPT',
  'MANUFACTURE_AND_MATH',
] as const;

export const CREATE_SPACE_UNIT_VALUE_SET = new Set<string>(
  CREATE_SPACE_UNIT_VALUES
);

// tasks types for select drop-down in Tasks page filter toolbar
export const TASKS_TYPES = [
  {
    value: 'CHALLENGE_SET',
    label: 'Challenge Set',
  },
  {
    value: 'CREATE_SPACE',
    label: 'Create Space',
  },
];

export const CREATE_SPACE_ASSIGNMENT_REPORT_SECTION_LABELS = {
  CRITERIA: 'Criteria',
  CONSTRAINTS: 'Constraints',
  TESTING_RESULTS: 'Testing Results',
  REFLECTIONS: 'Reflections',
  REFLECTION_RESPONSES: 'Reflection Responses',
  FEELINGS_LOG: 'Feelings Log',
  KUDOS: 'Kudos',
  STEP_BY_STEP_REPLAY: 'Step by Step Replay',
  VIEW_REPLAY_IN_APP: 'View Replay In App',
} as const;

export const CREATE_SPACE_ASSIGNMENT_REPORT_MODAL_TITLES = {
  REFLECT: 'I WANTED TO SHARE...',
  CRITERIA_CONSTRAINTS: 'ENTER CRITERIA OR CONSTRAINTS',
  RESULTS: 'Enter Results',
} as const;

export const CREATE_SPACE_ASSIGNMENT_REPORT_BUTTON_LABELS = {
  SAVE: 'Save Your Ideas!',
  CANCEL: 'Cancel',
  NEW_CRITERIA: 'NEW CRITERIA',
  NEW_CONSTRAINT: 'NEW CONSTRAINT',
  NEW_RESULT: 'NEW RESULT',
  NEW_REFLECTION: 'NEW REFLECTION',
} as const;

export const CREATE_SPACE_ASSIGNMENT_REPORT_PLACEHOLDER_TEXT = {
  REFLECT: 'Explanatory text here...',
  CRITERIA: 'Enter your design criteria here...',
  CONSTRAINTS: 'Enter your design constraints here...',
  RESULTS: 'Explanatory text here...',
} as const;

export const CREATE_SPACE_ASSIGNMENT_REPORT_MAX_LENGTHS = {
  REFLECTION: 500,
  CRITERIA_CONSTRAINTS: 1000,
  RESULTS: 1000,
} as const;

export const CREATE_SPACE_ASSIGNMENT_REPORT_FILE_UPLOAD = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_FILES: 1,
  ACCEPTED_TYPES: {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/webp': ['.webp'],
  },
} as const;

export const CREATE_SPACE_ASSIGNMENT_REPORT_ANIMATION_DURATIONS = {
  BUTTON_HOVER: 200,
  MODAL_FADE_IN: 200,
  BUTTON_SPRING: {
    stiffness: 260,
    damping: 20,
    delay: 0.1,
  },
} as const;

export const CREATE_SPACE_ASSIGNMENT_REPORT_RATE_LIMITS = {
  WINDOW_MS: 20000, // 20 seconds
  KUDOS_PER_WINDOW: 5,
  FEELINGS_PER_WINDOW: 5,
  RECENT_KUDOS_TIMEOUT_MS: 5000, // 5 seconds
} as const;

export const MESSAGES = {
  ERROR: {
    UNAUTHORIZED: 'Unauthorized',
    INVALID_ASSIGNMENT: 'Invalid assignment ID',
    NO_IMAGE: 'No image provided',
    FILE_TOO_LARGE: 'File too large. Maximum size is 5MB',
    INVALID_FILE_TYPE: 'Unsupported file type. Please use JPG, PNG, or WebP',
    INAPPROPRIATE_CONTENT: 'Image contains inappropriate content',
    UPLOAD_FAILED: 'Failed to upload image',
    SAVE_FAILED: 'Failed to save. Please try again.',
    VALIDATION_FAILED: 'Image validation failed',
    NO_CONTENT: 'Please add content to at least one section',
    ASSIGNMENT_NOT_FOUND: 'Assignment not found or access denied',
    STUDENT_NOT_IN_GROUP: 'Student does not belong to that assignment',
    NETWORK_ERROR: 'Network error. Please check your connection.',
    ITERATION_MISMATCH: 'Iteration mismatch detected',
  },
  SUCCESS: {
    IMAGE_VALIDATED: 'Image validated successfully',
    IMAGE_UPLOADED: 'Image uploaded successfully',
    IMAGE_UPDATED: 'Image updated successfully',
    SAVED: 'Saved successfully',
    FEELING_UPDATED: 'Feeling updated!',
    KUDOS_SENT: 'Kudos sent successfully!',
  },
  WARNING: {
    FACES_DETECTED:
      'Image contains face(s). Consider using a different image for privacy.',
    UNSAVED_CHANGES:
      'You have unsaved changes. Are you sure you want to continue?',
    RATE_LIMIT: 'Too many kudos! Please wait a moment.',
    OVERWRITE_IMAGE: 'This will replace the existing image. Continue?',
  },
  INFO: {
    LOADING: 'Loading...',
    SAVING: 'Saving...',
    VALIDATING: 'Validating image...',
    UPLOADING: 'Uploading image...',
  },
} as const;
